/* eslint-disable radix */

export class GetDuration {
  getSubstractMillis = (start, end) => {
    const startTimestamp = new Date(start).getTime();
    const endTimestamp = new Date(end).getTime();
    return endTimestamp - startTimestamp;
  };

  renderTimeFromMillis = millis => {
    // const hours = parseInt((millis / (1000 * 60 * 60)) % 24);
    const hours = parseInt(millis / 1000 / 60 / 60);
    const minutes = parseInt((millis / (1000 * 60)) % 60);
    // const seconds = parseInt((millis / 1000) % 60);

    return `
      ${hours > 9 ? '' : '0'}${hours} :
      ${minutes > 9 ? '' : '0'}${minutes}
    `;
  };

  getOneDuration = (start, end) => {
    const totalTimeStamp = this.getSubstractMillis(start, end);

    const duration = this.renderTimeFromMillis(totalTimeStamp);
    //return !start || !end ? 'valeur(s) manquante(s)' : renderTime;
    return duration;
  };

  getEditableDuration = (start, end) => {
    const totalTimeStamp = this.getSubstractMillis(start, end);

    const hours = parseInt(totalTimeStamp / 1000 / 60 / 60);
    const minutes = parseInt((totalTimeStamp / (1000 * 60)) % 60);
    // const seconds = parseInt((totalTimeStamp / 1000) % 60);

    return `${hours > 9 ? '' : '0'}${hours}:${
      minutes > 9 ? '' : '0'
    }${minutes}`;
  };

  getNewEndDateAfterEditingContribution = (newDurationString, start) => {
    const durationHoursInMillis =
      parseInt(`${newDurationString[0]}${newDurationString[1]}`) * 3600000;
    const durationMinsInMillis =
      parseInt(`${newDurationString[3]}${newDurationString[4]}`) * 60000;
    const editedDuration = durationHoursInMillis + durationMinsInMillis;

    const startTimeStamp = Date.parse(start);
    const newEndDateTimeStamp = new Date(startTimeStamp + editedDuration);
    return newEndDateTimeStamp.toUTCString();
  };

  getAllDuration = contributions => {
    if (contributions) {
      const contributionsObject = Object.entries(contributions).map(
        contribution => {
          return Object.assign({}, { id: contribution[0] }, contribution[1]);
        }
      );
      const counter = [];
      contributionsObject.map(contribution => {
        const { start, end } = contribution;
        const result = this.getSubstractMillis(start, end);
        return counter.push(result || 0);
      });
      const totalDuration = this.renderTimeFromMillis(
        counter.reduce((a, b) => a + b, 0)
      );
      //return `Durée totale de contributions ${renderTime}`;
      return totalDuration;
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/methods/GetDuration.js